<template>
    <div class="custom-header-checkbox">
        <input type="checkbox" ref="headerCheckbox" v-model="isChecked" @change="onCheckboxChange" />
    </div>
</template>

<script>
export default {
    name: 'CustomHeaderCheckbox',
    data() {
        return {
            isChecked: false
        };
    },
    beforeMount() {
        this.params.api.addEventListener('selectionChanged', this.onSelectionChanged);
        this.params.api.addEventListener('modelUpdated', this.onSelectionChanged);
        this.params.api.addEventListener('paginationChanged', this.onSelectionChanged);
    },
    mounted() {
        this.onSelectionChanged();
    },
    beforeDestroy() {
        if (this.params && this.params.api) {
            this.params.api.removeEventListener('selectionChanged', this.onSelectionChanged);
            this.params.api.removeEventListener('modelUpdated', this.onSelectionChanged);
            this.params.api.removeEventListener('paginationChanged', this.onSelectionChanged);
        }
    },

    methods: {
        getPageRowIndices() {
            const { api } = this.params;
            const pageSize = api.paginationGetPageSize();
            const currentPage = api.paginationGetCurrentPage();
            const totalRows = api.getDisplayedRowCount();

            const startIndex = currentPage * pageSize;
            const endIndex = Math.min(startIndex + pageSize, totalRows);

            return { startIndex, endIndex };
        },
        onCheckboxChange() {
            const { api } = this.params;
            const { startIndex, endIndex } = this.getPageRowIndices();

            // Only select/deselect rows on the current page (preserve other pages' selections)
            for (let i = startIndex; i < endIndex; i++) {
                const node = api.getDisplayedRowAtIndex(i);
                if (node && !node.group) {
                    node.setSelected(this.isChecked, false, 'headerCheckboxToggle');
                }
            }
        },
        onSelectionChanged(event) {
            if (event && event.source === 'headerCheckboxToggle') {
                return;
            }

            const { api } = this.params;
            const checkbox = this.$refs.headerCheckbox;
            if (!api || !checkbox)
                return;

            const { startIndex, endIndex } = this.getPageRowIndices();
            let selectedCount = 0;
            let totalNodesOnPage = 0;

            for (let i = startIndex; i < endIndex; i++) {
                const node = api.getDisplayedRowAtIndex(i);
                if (node && !node.group) {
                    // eslint-disable-next-line no-plusplus
                    totalNodesOnPage++;
                    if (node.isSelected()) {
                        // eslint-disable-next-line no-plusplus
                        selectedCount++;
                    }
                }
            }

            if (totalNodesOnPage === 0) {
                this.isChecked = false;
                checkbox.indeterminate = false;
            } else if (selectedCount === totalNodesOnPage) {
                this.isChecked = true;
                checkbox.indeterminate = false;
            } else if (selectedCount === 0) {
                this.isChecked = false;
                checkbox.indeterminate = false;
            } else {
                this.isChecked = false;
                checkbox.indeterminate = true;
            }
        }
    }
};
</script>

<style scoped>
.custom-header-checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
</style>
